import { useState, useEffect } from 'react';
import * as THREE from 'three';

export const useSimpleTextures = (textureConfig) => {
  const [textures, setTextures] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!textureConfig) {
      setTextures(null);
      setLoading(false);
      return;
    }

    const loadTextures = async () => {
      try {
        setLoading(true);
        setError(null);
        
        const loader = new THREE.TextureLoader();
        const result = {};

        // Load floor textures
        if (textureConfig.floor) {
          const floor = textureConfig.floor;
          result.floor = {};
          
          if (floor.color) {
            result.floor.color = loader.load(floor.path + floor.color);
            result.floor.color.wrapS = result.floor.color.wrapT = THREE.RepeatWrapping;
            result.floor.color.repeat.set(...floor.repeat);
          }
          
          if (floor.normal) {
            result.floor.normal = loader.load(floor.path + floor.normal);
            result.floor.normal.wrapS = result.floor.normal.wrapT = THREE.RepeatWrapping;
            result.floor.normal.repeat.set(...floor.repeat);
          }
          
          if (floor.roughness) {
            result.floor.roughness = loader.load(floor.path + floor.roughness);
            result.floor.roughness.wrapS = result.floor.roughness.wrapT = THREE.RepeatWrapping;
            result.floor.roughness.repeat.set(...floor.repeat);
          }
        }

        // Load wall textures
        if (textureConfig.walls) {
          const walls = textureConfig.walls;
          result.walls = {};
          
          if (walls.color) {
            result.walls.color = loader.load(walls.path + walls.color);
            result.walls.color.wrapS = result.walls.color.wrapT = THREE.RepeatWrapping;
            result.walls.color.repeat.set(...walls.repeat);
          }
          
          if (walls.normal) {
            result.walls.normal = loader.load(walls.path + walls.normal);
            result.walls.normal.wrapS = result.walls.normal.wrapT = THREE.RepeatWrapping;
            result.walls.normal.repeat.set(...walls.repeat);
          }
          
          if (walls.roughness) {
            result.walls.roughness = loader.load(walls.path + walls.roughness);
            result.walls.roughness.wrapS = result.walls.roughness.wrapT = THREE.RepeatWrapping;
            result.walls.roughness.repeat.set(...walls.repeat);
          }
        }

        setTextures(result);
        setLoading(false);
      } catch (err) {
        console.error('Error loading textures:', err);
        setError(err);
        setLoading(false);
      }
    };

    loadTextures();
  }, [textureConfig]);

  return { textures, loading, error };
};